var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledBackIcon = styled.svg `
  width: ${(props) => props.width || '16px'};
  height: ${(props) => props.height || '16px'};
  flex-shrink: 0;

  path {
    fill: ${(props) => props.iconColor || 'currentColor'};
  }
`;
export const BackIcon = (_a) => {
    var { iconColor } = _a, props = __rest(_a, ["iconColor"]);
    return (_jsxs(StyledBackIcon, Object.assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", iconColor: iconColor }, props, { children: [_jsx("g", { clipPath: "url(#clip0_18226_3165)", children: _jsx("path", { d: "M7.21859 7.99999L10.5186 11.3L9.57592 12.2427L5.33325 7.99999L9.57592 3.75732L10.5186 4.69999L7.21859 7.99999Z", fill: "#1B244B" }) }), _jsx("defs", { children: _jsx("clipPath", { id: "clip0_18226_3165", children: _jsx("rect", { width: "16", height: "16", fill: "white" }) }) })] })));
};
export default BackIcon;
//# sourceMappingURL=BackIcon.js.map